import { SharedModule } from 'src/app/shared/shared.module'

import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import { SaleItemRoutingModule } from './sale-item-routing.module'
import { SaleItemEffects } from './sale-item.effects'
import * as fromSaleItem from './sale-item.reducer'
import { SaleItemSerializer } from './sale-item.serializer'
import { SaleItemService } from './sale-item.service'
import { SaleItemTableComponent } from './table/show.component'
import { GetSaleItemProductQtyPipe } from './table/get-sale-item-product-qty.pipe'
import { GetSaleItemProductPricePipe } from './table/get-sale-item-product-price.pipe'
import { SaleItemPriceDetailsComponent } from './table/sale-item-price-details/sale-item-price-details.component'
import { GetSaleItemCoursePricePipe } from './table/get-sale-item-course-price.pipe'
import { GetSaleItemRentalProductPricePipe } from './table/get-sale-item-rental-product-price.pipe'
import { RentalModule } from '../../rental/rental.module'
import { GetSaleItemSubscriptionPricePipe } from './table/get-sale-item-subscription-price.pipe'

@NgModule({
  imports: [
    CommonModule,
    SaleItemRoutingModule,
    SharedModule,
    StoreModule.forFeature(
      fromSaleItem.FEATURE_NAME,
      fromSaleItem.saleItemReducer
    ),
    EffectsModule.forFeature([SaleItemEffects]),
    RentalModule
  ],
  declarations: [
    SaleItemTableComponent,
    GetSaleItemProductQtyPipe,
    GetSaleItemProductPricePipe,
    SaleItemPriceDetailsComponent,
    GetSaleItemCoursePricePipe,
    GetSaleItemRentalProductPricePipe,
    GetSaleItemSubscriptionPricePipe
  ],
  exports: [SaleItemTableComponent],
  providers: [
    SaleItemService,
    {
      provide: SaleItemSerializer,
      useClass: SaleItemSerializer
    }
  ]
})
export class SaleItemModule {}
